<template>
    <div class="input-message-box-user">
        <input v-model="message" @keyup.enter="send" type="text" title="Enter your message here" placeholder="Type your message..." style="width: 560px">
        <i class="material-icons">chat_bubble_outline</i>
    </div>
</template>

<script>
export default {
    props: ['songId', 'conversationId'],

    data() {
        return {
            message: '',
        }
    },

    methods: {
        send() {
            if (this.message.length < 1) {
                return;
            }

            var message = { message: this.message };
            this.$http.post(this.storeMessageEndpoint, message).then((success) => {
                this.$root.$emit('currentUserSentMessage', this.message);
                this.resetMessage();
            });
        },

        resetMessage() {
            this.message = '';
        },
    },

    computed: {
        storeMessageEndpoint() {
            return App.restApi + '/api/song/' + this.songId + '/conversation/' + this.conversationId + '/messages';
        },
    },
}
</script>
